/** SCHOLARSHIP DATA */

export const SCHOLARSHIP_AWARD_TYPES = [
  'Scholarship',
  'Grant',
  'Prize',
  'Fellowship',
  'Forgivable Loan',
] as const;

export type ScholarshipAwardType = (typeof SCHOLARSHIP_AWARD_TYPES)[number];

export type Scholarship = Readonly<{
  id: number;
  peterson_id: number;
  name: string;
  media_url?: string;
  donor: string;
  program_url: string;
  description: string;
  award_type: ScholarshipAwardType;
  award_category: string | null;
  award_classification: string;

  award_number_of_range_min: number | null;
  award_number_of_range_max: number | null;
  award_money_range_min: number | null;
  award_money_range_max: number | null;

  award_total_num_prev_year: number | null;
  award_total_dollar_prev_year: number | null;
  award_total_applicant_prev_year: number | null;

  submission_type: string | null;
  submission_email: string | null;
  submission_link: string | null;
  submission_deadline: string | null;
  submission_start_date: string | null;
  submission_deadline_priority: string | null;

  eligibility_time_status: string | null;
  eligibility_level_of_study: string | null;
  eligibility_institution_type: string | null;
  eligibility_applicant_type_limited_hs: boolean | null;
  eligibility_applicant_hs_can_apply: boolean | null;
  eligibility_citizenship: string | null;
  eligibility_test_score: string | null;
  eligibility_age_min: number | null;
  eligibility_age_max: number | null;
  eligibility_gender: string | null;
  eligibility_marital_status: string | null;
  eligibility_race_ethnicity: string | null;
  eligibility_disability_type: string | null;
  eligibility_military_type: string | null;
  eligibility_9_11_related: boolean | null;

  prog_restrict_state_residence: string | null;
  prog_restrict_state_usage: string | null;
  prog_restrict_county_residence: string | null;
  prog_restrict_institution: string | null;
  prog_restrict_corp_affiliation: string | null;
  prog_restrict_area_study: string | null;
  prog_restrict_employment: string | null;
  prog_restrict_ethnicity_heritage: string | null;
  prog_restrict_country_citizenship: string | null;
  prog_restrict_religious_affiliation: string | null;
  prog_restrict_talent: string | null;
  prog_restrict_civic_club: string | null;

  renewability: boolean | null;

  application_requirements: string | null;
  application_submission_method: string | null;
  application_submission_destination: string | null;
  application_fee: number | null;
  application_automatic_consideration: string | null;

  contact_name: string | null;
  contact_title: string | null;
  contact_address: string | null;
  contact_details: string | null;

  created_at: Date;
  updated_at: Date;
}>;
